var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "ul",
    { staticClass: "panel" },
    _vm._l(_vm.services, function (service) {
      return _c(
        "li",
        { staticClass: "panel-block is-flex is-justify-content-space-between" },
        [
          _c(
            "div",
            { staticClass: "is-flex" },
            [
              _c(
                "router-link",
                { attrs: { to: `/categories/${service.serviceId}/root` } },
                [
                  _c("span", { staticClass: "has-text-weight-semibold" }, [
                    _vm._v(_vm._s(service.label)),
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "ml-1" }, [
                    _vm._v("(" + _vm._s(service.serviceId) + ")"),
                  ]),
                ]
              ),
            ],
            1
          ),
        ]
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }